import { Stack, FormLabel, Checkbox, Box } from "@mui/material";
import { AddMemberFormDataUpdated } from "../AddMemberForm";
import { SxProps } from "@mui/system/styleFunctionSx/styleFunctionSx";
import { inputStateUpdate } from "../utility";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";

export type CheckBoxItemType = {
  stateKey: string;
  value: string;
  checked: boolean;
  required? : boolean;
}[];

export type CheckBoxFieldProps = {
  items: CheckBoxItemType;
  setState: Function;
  defaultValue?: string | boolean;
  direction?: "row" | "column";
};

const CheckBoxSection: React.FC<CheckBoxFieldProps> = (
  props: CheckBoxFieldProps
) => {
  const { items, setState, defaultValue, direction } = props;
  const [checkboxState, setCheckboxState] = useState<CheckBoxItemType>(items);
  const theme = useTheme();
  const changehandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    inputStateUpdate(
      value,
      setState,
      (e.target as HTMLInputElement).value,
      () => e.target.checked
    );
  };

  return (
    <Box display={"flex"} flexDirection={direction ?? "row"}>
      {items.map((item, i) => {
        return (
          <Stack
            key={i}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
          >
            <Checkbox
              required={item.required}
              checked={item.checked}
              value={item.stateKey}
              onChange={changehandler}
              size="small"
              sx={{
                color: theme?.color?.secondary,
                "&.Mui-checked": {
                  color: theme?.color?.secondary,
                },
              }}
            />
            <FormLabel sx={{ lg: { fontSize: "2rem" } }}>
              {item.value}
            </FormLabel>
          </Stack>
        );
      })}
    </Box>
  );
};

export default CheckBoxSection;
